<template>
	<v-tabs
		v-model="tab"
		class="mt-1"
	>
		<v-tab
			v-for="(item, index) in tabs"
			:key="index"
			:class="['px-2', 'caption', index ? '' : 'ml-2', 'mr-1']"
		>
			<MyTabTitle
				:title="item.title"
				:component="item.component"
			/>
		</v-tab>
		<v-tabs-items v-model="tab">
			<v-tab-item v-for="(item) in tabs" :key="item.component" class="pa-4 pt-5">
				<component :is="item.component" v-bind:data="data" :key="getKey(item.component)"></component>
			</v-tab-item>
		</v-tabs-items>
	</v-tabs>
</template>

<script>
	import MyTabTitle from "./MyTabTitle";

	export default {
		data: function(){
			var data = {
				tab: 0
			};
			return data;
		},
		props: {
			tabs: Array,
			data: Object,
			uniqueKey: Number
		},
		components: {
			"map-layers": () => ({
				component: import("./tabs/MapLayers")
			}),
			"service-search": () => ({
				component: import("./tabs/ServiceSearch")
			}),
			"settings": () => ({
				component: import("./tabs/Settings")
			}),
			"my-objects": () => ({
				component: import("./tabs/MyObjects")
			}),
			"print-settings": () => ({
				component: import("./tabs/PrintSettings")
			}),
			MyTabTitle
		},
		methods: {
			getKey: function(module){
				if (module != "service-search") { // Paiešką paranku cache'uoti!!! Pereinant nuo vieno žemėlapio prie kito turėsime tos pačios paieškos rezultatus
					return this.uniqueKey;
				}
			},
			shareAtlas: function(atlas){
				this.$vBus.$emit("show-atlas-sharing-form", atlas);
			}
		}
	}
</script>

<style scoped>
	.v-tab {
		min-width: 0;
		max-width: 120px;
		line-height: 1.3;
	}
</style>